import React from 'react';
import PropTypes from 'prop-types';

import Banner from './Banner';
import { useBannerContext } from '../../common/contexts/BannerContext';
import { useAppContext } from '../../common/contexts/AppContext';

import { HOW_TO_ASSESS_CP_LINK } from '../../common/navigation/navigation';
import { ASSESSMENT_TYPE } from '../../constants/assessments';

const BMCPBanner = ({ studentUid }) => {
    const bannerContext = useBannerContext();
    const { classId, selectedAssessmentType } = useAppContext();
    const {
        actions: { hideBMCPBanner },
        isBannerVisible,
    } = bannerContext;

    const dismissHandler = () =>
        hideBMCPBanner({
            classId,
            studentUid,
        });

    const isBMCPBannerVisible = isBannerVisible(classId, studentUid, 'isBMCPBannerVisible');

    return isBMCPBannerVisible && selectedAssessmentType === ASSESSMENT_TYPE.BM ? (
        <Banner
            isInformation
            isDismissible
            dismissHandler={dismissHandler}
            className='dashboard-section dashboard-bm-section dashboard-decrease-padding'
        >
            <div>
                <div className='dashboard-title'>¿Cuál palabra?</div>
                <div className='dashboard-text'>
                    Se debe completar ¿Cuál palabra? para obtener un puntaje compuesto en los grados
                    2-6 (no se requiere para el 1<sup>er</sup> grado). Puede ver cómo completar
                    ¿Cuál palabra? por internet o cómo ingresar los resultados de papel y
                    lápiz&nbsp;
                    <a
                        className='dashboard-maze-link'
                        href={HOW_TO_ASSESS_CP_LINK}
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        aquí <i className='dashboard-navigation-link-icon' />
                    </a>
                    .
                </div>
            </div>
        </Banner>
    ) : null;
};

BMCPBanner.propTypes = {
    studentUid: PropTypes.string.isRequired,
};

export default BMCPBanner;
